import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { AbioMedChatComponent } from './components/abiomed-chat/abiomed-chat.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RoleplayStep1Component } from './components/roleplay/roleplay-step1/roleplay-step1.component';
import { RoleplayStep2Component } from './components/roleplay/roleplay-step2/roleplay-step2.component';
import { RoleplayStep3Component } from './components/roleplay/roleplay-step3/roleplay-step3.component';
import { RoleplayStep4Component } from './components/roleplay/roleplay-step4/roleplay-step4.component';
import { RoleplayStep5Component } from './components/roleplay/roleplay-step5/roleplay-step5.component';
import { RoleplayStep6Component } from './components/roleplay/roleplay-step6/roleplay-step6.component';
import { RoleplayContainerComponent } from './components/roleplay/roleplay-container/roleplay-container.component';
import { RoleplayProfileComponent } from './components/roleplay/roleplay-profile/roleplay-profile.component';
import { TraineeDasboardComponent } from './components/trainee-dasboard/trainee-dasboard.component'
import { RoleplayAssignComponent } from './components/roleplay-assign/roleplay-assign.component';
import { TraineeListComponent } from './components/trainee-list/trainee-list.component';
import { TraineeDetailComponent } from './components/trainee-detail/trainee-detail.component';
import { UserAssignedRoleplayComponent } from './components/user-assigned-roleplay/user-assigned-roleplay.component';
import { CustFaqComponent } from './components/cust-faq/cust-faq.component';
import { DashboardTrainerComponent } from './components/dashboard-trainer/dashboard-trainer.component';
import { TrainerAssignedRoleplayComponent } from './components/trainer-assigned-roleplay/trainer-assigned-roleplay.component';
import { BrowserUtils } from '@azure/msal-browser';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { UnauthorizeduserComponent } from './components/unauthorizeduser/unauthorizeduser.component';
import { VeevaVaultDashboardComponent } from './components/veeva-vault-dashboard/veeva-vault-dashboard.component';
import { DocumentListComponent } from './components/document-list/document-list.component';
import { CreateProfileComponent } from './components/create-profile/create-profile.component';
import { SystemPromptTabComponent } from './components/system-prompt-tab/system-prompt-tab.component';
import { DoctorProfileComponent } from './components/doctor-profile/doctor-profile.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { FeedbackTraineeComponent } from './components/feedback-trainee/feedback-trainee.component';
import { HelpDocContentComponent } from './components/help-doc-content/help-doc-content.component';
import { SpeechToTextComponent } from './components/speech-to-text/speech-to-text.component';
import { PreLoginComponent } from './components/pre-login/pre-login.component';
import { EmailTemplateComponent } from './components/email-template/email-template.component';
import { CreateTemplateComponent } from './components/create-template/create-template.component';
import { ProfileInfoComponent } from './components/profile-info/profile-info.component';
import { ProductTypeComponent } from './components/product-type/product-type.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { CreateSourceComponent } from './components/create-source/create-source.component';
import { AmpDataSourceListComponent } from './components/amp-data-source-list/amp-data-source-list.component';
import { CustomizeDialogComponent } from './components/customize-dialog/customize-dialog.component';
import { QuestionListComponent } from './components/question-list/question-list.component';
import { RoleplayFeedbackComponent } from './components/roleplay-feedback/roleplay-feedback.component';
import { CommentHistoryComponent } from './components/feedback/comment-history/comment-history.component';
import { RoleplayHistoryComponent } from './components/history/history.component';
import { RequestListComponent } from './components/ContactCenter/request-list/request-list.component';
import { RequestDetailComponent } from './components/ContactCenter/request-detail/request-detail.component';
import { DetailsDescriptionComponent } from './components/ContactCenter/details-description/details-description.component';
import { RoleplayFeedbackListComponent } from './components/ContactCenter/roleplay-feedback-list/roleplay-feedback-list.component';
import { RoleplayFeedbackDetailComponent } from './components/ContactCenter/roleplay-feedback-detail/roleplay-feedback-detail.component';

const routes: Routes = [
  { path: 'roleplay', loadChildren: () => import('./v2/modules/roleplay/roleplay-routing.module').then(m => m.RoleplayRoutingModule) },
  { path: 'admin', loadChildren: () => import('./v2/modules/admin/admin-routing.module').then(m => m.AdminRoutingModule) },
  { path: 'quiz', loadChildren: () => import('./v2/modules/quiz/quiz-routing.module').then(m => m.QuizRoutingModule) },
  { path: 'app-abiomed-chat', component: AbioMedChatComponent },
  { path: 'app-amp-data-source-list', component: AmpDataSourceListComponent },
  { path: 'app-roleplay-history/:chat_session_id', component: RoleplayHistoryComponent },
  { path: 'app-confirmation-dialog', component: ConfirmationDialogComponent },
  { path: 'app-create-profile', component: CreateProfileComponent },
  { path: 'app-create-profile/:id', component: CreateProfileComponent },
  { path: 'app-create-source', component: CreateSourceComponent },
  { path: 'app-create-template', component: CreateTemplateComponent },
  { path: 'app-create-template/:id', component: CreateTemplateComponent },
  { path: 'app-cust-faq', component: CustFaqComponent },
  { path: 'app-customize-dialog', component: CustomizeDialogComponent },
  { path: 'app-dashboard', component: DashboardComponent },
  { path: 'app-dashboard-trainer', component: DashboardTrainerComponent },
  { path: 'app-doctor-profile', component: DoctorProfileComponent },
  { path: 'app-document-list', component: DocumentListComponent },
  { path: 'app-email-template', component: EmailTemplateComponent },
  { path: 'app-feedback', component: FeedbackComponent },
  { path: 'app-feedback-trainee', component: FeedbackTraineeComponent },
  { path: 'app-header', component: HeaderComponent },
  { path: 'app-help-doc-content', component: HelpDocContentComponent },
  { path: 'app-home', component: HomeComponent },
  { path: 'app-pre-login', component: PreLoginComponent },
  { path: 'app-product-list', component: ProductListComponent },
  { path: 'app-product-type', component: ProductTypeComponent },
  { path: 'app-profile-info', component: ProfileInfoComponent },
  { path: 'app-question-list', component: QuestionListComponent },
  { path: 'app-roleplay-assign', component: RoleplayAssignComponent },
  { path: 'app-roleplay-container', component: RoleplayContainerComponent },
  { path: 'app-roleplay-container/:id', component: RoleplayContainerComponent },
  { path: 'app-roleplay-feedback/:id', component: RoleplayFeedbackComponent },
  { path: 'app-roleplay-profile', component: RoleplayProfileComponent },
  { path: 'app-roleplay-step1', component: RoleplayStep1Component },
  { path: 'app-roleplay-step2', component: RoleplayStep2Component },
  { path: 'app-roleplay-step3', component: RoleplayStep3Component },
  { path: 'app-roleplay-step4', component: RoleplayStep4Component },
  { path: 'app-roleplay-step5', component: RoleplayStep5Component },
  { path: 'app-roleplay-step6', component: RoleplayStep6Component },
  { path: 'app-speech-to-text', component: SpeechToTextComponent },
  { path: 'app-system-prompt-tab', component: SystemPromptTabComponent },
  { path: 'app-trainee-dasboard', redirectTo: 'roleplay/training-dashboard', pathMatch: 'full' },
  { path: 'app-trainee-detail', component: TraineeDetailComponent },
  { path: 'app-trainee-list', component: TraineeListComponent },
  { path: 'app-trainer-assigned-roleplay/:sessionId/:selectedUserId/:firstName/:lastName', component: TrainerAssignedRoleplayComponent },
  { path: 'app-unauthorizeduser', component: UnauthorizeduserComponent },
  { path: 'app-user-assigned-roleplay', component: UserAssignedRoleplayComponent },
  { path: 'app-veeva-vault-dashboard', component: VeevaVaultDashboardComponent },
  { path: 'app-comment-history', component: CommentHistoryComponent },
  { path: 'app-request-list', component: RequestListComponent },
  { path: 'app-request-detail/:id', component: RequestDetailComponent },
  { path: 'app-details-description/:id', component: DetailsDescriptionComponent },
  { path: 'app-cc-roleplay-feedback', component: RoleplayFeedbackListComponent },
  { path: 'app-cc-roleplay-feedback-detail/:id', component: RoleplayFeedbackDetailComponent },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // Don't perform initial navigation in iframes or popups
    initialNavigation:
      !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
        ? "enabledNonBlocking"
        : "disabled", // Set to enabledBlocking to use Angular Universal
  }),],
  exports: [RouterModule]
})
export class AppRoutingModule { }
